import { FeatureFlagEnum } from '@shared/enums/feature-flag.enum';
import { EnvironmentModel } from '@shared/models/environment.model';

class EnvironmentImpl implements EnvironmentModel {
  production = false;
  sentryDSN = 'https://70dd0b21d048139bc768b13b07c9ef26@o74825.ingest.us.sentry.io/4509779295076352';

  featureConfig = {
    [FeatureFlagEnum.CreditReportClientTabs]: true,
    [FeatureFlagEnum.CreditReportSettings]: true,
    [FeatureFlagEnum.PreCompletions]: true,
    [FeatureFlagEnum.GlobalSearch]: true,
    [FeatureFlagEnum.EmailPreviewer]: true,
    [FeatureFlagEnum.MabTheme]: false,
    [FeatureFlagEnum.ActivityLog]: true,
  };

  googleCloudPlatformApiKey = 'AIzaSyA9-yauNMAmmzA7SU8kLuurSue8KrbJ7sU';
  maintenanceUrl = 'https://storage.googleapis.com/dashlystage-ui-apps-config/config.json';

  urls = {
    clientPortalUrl: 'https://my.dashly-stage.com',
    adviserPortalUrl: 'https://port.dashly-stage.com',
    apiUrl: 'https://api.dashly-stage.com',
  };

  companyIds = {
    dashlyCompanyId: '5',
  };

  networkIds = { mabId: '1' };
}

export const environment = new EnvironmentImpl();
